import React, { useState, useEffect } from 'react';
import Filters from './components/Filters';
import Pagination from './components/Pagination';
import ImageModal from './components/ImageModal';
import WelcomeModal from './components/WelcomeModal';
import metadata from './XCOPY--COPE-SALADA-generations--metadata.json';
import 'tailwindcss/tailwind.css';

const App = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filters, setFilters] = useState({ base: '', vision: '', noise: '', flavour: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 16;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImage) {
        if (event.key === 'ArrowRight') {
          handleNextImage();
        } else if (event.key === 'ArrowLeft') {
          handlePreviousImage();
        } else if (event.key === 'Escape') {
          setSelectedImage(null);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage]);

  const applyFilters = (item) => {
    return item.traits.every((trait) => {
      if (filters[trait.type]) {
        return filters[trait.type] === trait.value;
      }
      return true;
    });
  };

  const handleFilterChange = (filterType, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));
  };

  const resetFilters = () => {
    setFilters({ base: '', vision: '', noise: '', flavour: '' });
  };

  const filteredMetadata = metadata.filter(applyFilters);
  const totalPages = Math.ceil(filteredMetadata.length / itemsPerPage);
  const displayedItems = filteredMetadata.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePreviousImage = () => {
    if (selectedImage) {
      const currentIndex = filteredMetadata.findIndex((item) => item.fileName === selectedImage);
      if (currentIndex > 0) {
        setSelectedImage(filteredMetadata[currentIndex - 1].fileName);
      }
    }
  };

  const handleNextImage = () => {
    if (selectedImage) {
      const currentIndex = filteredMetadata.findIndex((item) => item.fileName === selectedImage);
      if (currentIndex < filteredMetadata.length - 1) {
        setSelectedImage(filteredMetadata[currentIndex + 1].fileName);
      }
    }
  };

  return (
    <div className="min-h-screen text-[#00f6ff] flex flex-col md:flex-row">
      <WelcomeModal />
      <Filters
        filters={filters}
        handleFilterChange={handleFilterChange}
        resetFilters={resetFilters}
        metadata={metadata}
      />
      <main className="w-full md:w-3/4 p-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {displayedItems.map((item) => (
            <div key={item.fileName} onClick={() => setSelectedImage(item.fileName)} className="cursor-pointer">
              <img
                src={`./images/${item.fileName}`}
                alt={item.fileName}
                className="w-full h-auto border-2 border-[#632af8] rounded transition-transform transform hover:scale-105 hover:border-[#00f6ff]"
              />
            </div>
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />

        {selectedImage && (
          <ImageModal
            selectedImage={selectedImage}
            handlePreviousImage={handlePreviousImage}
            handleNextImage={handleNextImage}
            setSelectedImage={setSelectedImage}
          />
        )}
      </main>
    </div>
  );
};

export default App;